<!-- monitoring-request-edit.component.html -->
<div class="main-page cadastros">
  <div class="container-fluid">
    <app-title>Editar Solicitação de Monitoramento</app-title>

    <div class="row mt-3 no-gutters p-4 row-form">
      <div class="col-12">
        <form [formGroup]="reportOperationalForm" (ngSubmit)="submitForm()">
          <h2 class="mb-3">Dados da Solicitação de Monitoramento</h2>

          <div class="form-row">
        
            <div class="form-group col-3">
              <mat-form-field appearance="outline">
                <mat-label>Núm. Viagem</mat-label>
                <input
                  formControlName="tripNumber"
                  matInput
                  disabled
                  style="text-transform: uppercase"
                />
              </mat-form-field>
            </div>

            <div class="form-group col-md-3">
              <mat-form-field appearance="outline">
                <mat-label>Tipo de Análise</mat-label>
                <mat-select
                  formControlName="selectTypeAnalyze"
                  [(value)]="typeAnalyzeFilterSelected"
                  [(ngModel)]="typeAnalyzeFilterSelected"
                  (selectionChange)="filterCompany()"
                  disabled
                  required
                >
                  <mat-option
                    *ngFor="let type of typeAnalyzeSelect"
                    [value]="type.value"
                  >
                    {{ type.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="form-row">
            <div
              class="form-group col-md-3"
              *ngIf="typeAnalyzeFilterSelected === 'DRIVER_OPERATIONAL'"
            >
              <mat-form-field appearance="outline">
                <mat-label>Tipo de Empresa</mat-label>
                <mat-select
                  formControlName="selectCompany"
                  [(value)]="companyFilterSelected"
                  [(ngModel)]="companyFilterSelected"
                  (selectionChange)="filterCompany()"
                  disabled
                >
                  <mat-option
                    *ngFor="let type of companiesSelect"
                    [value]="type.name"
                  >
                    {{ type.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div
              class="form-group col-md-3"
              *ngIf="typeAnalyzeFilterSelected === 'DRIVER_OPERATIONAL'"
            >
              <mat-form-field appearance="outline">
                <mat-label>Empresa</mat-label>
                <input
                  type="text"
                  matInput
                  [formControl]="controlCompany"
                  [matAutocomplete]="autoEmpresa"
                  required
                  disabled
                />
                <mat-autocomplete
                  #autoEmpresa="matAutocomplete"
                  [displayWith]="displayCompany"
                >
                  <mat-option
                    *ngFor="let type of companiesFilter"
                    [value]="type"
                  >
                    {{ type.nmNome }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>

            <div
              class="form-group col-md-6"
              *ngIf="
                controlCompany.value != '' &&
                typeAnalyzeFilterSelected == 'DRIVER_OPERATIONAL'
              "
            >
              <mat-form-field appearance="outline">
                <mat-label>Motorista</mat-label>
                <input
                  type="text"
                  matInput
                  [formControl]="controlDriver"
                  [matAutocomplete]="autoDriver"
                  required
                />
                <mat-autocomplete
                  #autoDriver="matAutocomplete"
                  [displayWith]="displayDriver"
                >
                  <mat-option
                    *ngFor="let type of this.driversFiltered | async"
                    [value]="type"
                  >
                    {{ type.nmNome }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </div>

          <div class="form-row">
            <div
              class="form-group col-md-6"
              *ngIf="
                controlCompany.value &&
                typeAnalyzeFilterSelected == 'VEHICLE_OPERATIONAL'
              "
            >
              <mat-form-field appearance="outline">
                <mat-label>Placa / Frota</mat-label>
                <input
                  type="text"
                  matInput
                  [formControl]="controlVehicle"
                  [matAutocomplete]="autoTerminal"
                  required
                />
                <mat-autocomplete
                  #autoTerminal="matAutocomplete"
                  [displayWith]="displayTerminal"
                  (optionSelected)="onVehicleSelected($event.option.value)"
                >
                  <mat-option
                    *ngFor="let type of vehiclesFiltered | async"
                    [value]="type"
                  >
                    {{ type.cdPlaca }}/{{ type.frota }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>

            <div
              class="form-group col-md-3"
              *ngIf="
                controlCompany.value &&
                typeAnalyzeFilterSelected == 'VEHICLE_OPERATIONAL'
              "
            >
              <mat-form-field appearance="outline">
                <mat-label>Nome Motorista</mat-label>
                <input
                  formControlName="driverName"
                  matInput
                  style="text-transform: uppercase"
                  required
                />
              </mat-form-field>
            </div>

            <div
              class="form-group col-md-3"
              *ngIf="typeAnalyzeFilterSelected === 'VEHICLE_OPERATIONAL'"
            >
              <mat-form-field appearance="outline">
                <mat-label>Nome Empresa</mat-label>
                <input
                  type="text"
                  matInput
                  [formControl]="controlCompanyName"
                  placeholder="Nome da Empresa"
                  disabled
                />
              </mat-form-field>
            </div>
          </div>

          <h2 class="mb-3">Origem da Monitoração</h2>

          <div class="form-row">
            <div class="form-group col-3">
              <mat-form-field appearance="outline">
                <mat-label>Data Prevista para Viagem</mat-label>
                <input
                  formControlName="expectedDepartureDate"
                  type="datetime-local"
                  matInput
                  required
                />
              </mat-form-field>
            </div>

            <div class="form-group col-lg-3">
              <mat-form-field appearance="outline">
                <mat-label>Origem</mat-label>
                <input
                  formControlName="address"
                  style="text-transform: uppercase"
                  matInput
                  readonly
                  (click)="openOriginAddressPopup()"
                  placeholder="Clique para selecionar a origem"
                  required
                />
              </mat-form-field>
            </div>

            <div class="form-group col-md-3">
              <mat-form-field appearance="outline">
                <mat-label>Latitude</mat-label>
                <input formControlName="latitude" matInput readonly />
              </mat-form-field>
            </div>

            <div class="form-group col-md-3">
              <mat-form-field appearance="outline">
                <mat-label>Longitude</mat-label>
                <input formControlName="longitude" matInput readonly />
              </mat-form-field>
            </div>
          </div>

          <div formArrayName="listDestination" *ngIf="controlCompany.value">
            <div
              *ngFor="let item of destinationItems.controls; let i = index"
              [formGroupName]="i"
            >
              <div class="form-row">
                <div class="form-group col-lg-4">
                  <mat-form-field appearance="outline">
                    <mat-label>Destino</mat-label>
                    <input formControlName="address" matInput disabled />
                  </mat-form-field>
                </div>
                <div class="form-group col-lg-3">
                  <mat-form-field appearance="outline">
                    <mat-label>Latitude</mat-label>
                    <input formControlName="latitude" matInput disabled />
                  </mat-form-field>
                </div>
                <div class="form-group col-lg-3">
                  <mat-form-field appearance="outline">
                    <mat-label>Longitude</mat-label>
                    <input formControlName="longitude" matInput disabled />
                  </mat-form-field>
                </div>
                <div class="form-group col-lg-2" style="padding-top: 1%">
                  <a (click)="deleteDestinationItem(i)">
                    Excluir Destino
                    <img src="assets/img/trash.svg" height="20" alt="" />
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div
            class="form-group col-12 text-center"
            *ngIf="controlCompany.value"
          >
            <a class="repeat-line" (click)="addDestination()">
              <img src="assets/img/plus.svg" height="20" alt="" />
              Adicionar novo Destino
            </a>
          </div>

          <div *ngIf="errorMessage" class="alert alert-danger">
            {{ errorMessage }}
          </div>

          <div class="form-group mt-2 mb-0 text-center">
            <back-button></back-button>
            <button
              type="submit"
              [disabled]="!reportOperationalForm.valid"
              class="btn btn-salvar"
            >
              Atualizar Solicitação
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
